<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Port" subTitle="Forms" />

    <CreatePort />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreatePort from "@/components/Pages/Master/Port/CreatePort.vue";

export default defineComponent({
  name: "CreatePortPage",
  components: {
    PageTitle,
    CreatePort,
  },
});
</script>
